import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
export default {
  name: 'activityDetail',
  data() {
    return {
      menus: ['拼图小游戏', '答题小游戏', '作品征集'],
      activeIndex: 0,
      list: [],
      currentPage: 1,
      primaryList: [],
      total: 0
    };
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    changeIndex(index) {
      this.activeIndex = index;
      this.currentPage = 1;
      this.list = [];
      if (index == 2) return this.getActivitys();
      this.getDict(index);
    },
    changeCurrent(page) {
      this.currentPage = page;
      this.activeIndex == 2 ? this.getActivitys() : this.getDict(this.activeIndex, true);
    },
    getDict(type, isChange) {
      if (isChange) return this.list = this.primaryList[this.currentPage - 1];
      let code = type ? 'game1' : 'pintu';
      // let apiUrl = 'https://cloud-museum.chaoxing.com'
      let apiUrl = process.env.NODE_ENV == 'development' ? 'https://cloud-museum.chaoxing.com' : 'https://museum-backend.chaoxing.com';
      this.$ajax(`${apiUrl}/api/admin/front/dict/parent-museum?parentCode=${code}&museumCode=203966`).then(res => {
        this.primaryList = [];
        let list = res.data.data.map(item => {
          return {
            name: item.dictName,
            url: item.description,
            img: item.image
          };
        });
        this.total = list.length;
        let s_index = 0;
        list.map((item, index) => {
          if (index == s_index) {
            this.primaryList.push(list.slice(index, index += 4));
            s_index += 4;
          }
        });
        this.list = this.primaryList[0] ? this.primaryList[0] : [];
      });
    },
    openUrl(url) {
      location.href = url;
    },
    getActivitys() {
      let params = encodeURIComponent(`fid=203966&pageSize=4&pageNum=${this.currentPage}`);
      console.log(params);
      this.$ajax(`https://cloud-museum.chaoxing.com/api/micro-backend/front/activity/list?params=${params}`).then(res => {
        res = res.data.data;
        this.list = res.records.map(item => {
          return {
            name: item.activityName,
            url: item.activityPreviewUrl,
            img: item.coverUrl
          };
        });
        this.total = res.total;
      });
    }
  },
  created() {
    this.activeIndex = this.$route.query.type ? parseInt(this.$route.query.type) : 0;
    document.title = this.menus[this.activeIndex];
    this.activeIndex == 2 ? this.getActivitys() : this.getDict(this.activeIndex);
    if (this._isMobile()) {
      this.$cookie.set('_isMobile', true);
    } else {
      this.$cookie.delete('_isMobile');
    }
  },
  computed: {
    isMobile() {
      return this.$cookie.get('_isMobile');
    }
  }
};